import axios from "@/axios-service";
import { ResponseContent, responseContent  } from "../types";
import { classToPlain } from "class-transformer";
import { BulkUploadDTO, BulkResponseDTO } from "./types";

const MS_URL = "/senana/api/agronow/bulk";

export const create = async (dto: BulkUploadDTO): Promise<BulkResponseDTO> => axios
    .post(`${MS_URL}`, classToPlain(dto))
    .then(responseContent(BulkResponseDTO))
    .then(it => it.data);

